(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire44e7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire44e7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hvZMf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cc05409771aeea55$export$71511d61b312f219; });

var $2zPWk = parcelRequire("2zPWk");

var $91t4N = parcelRequire("91t4N");

var $eTJIp = parcelRequire("eTJIp");

var $537SV = parcelRequire("537SV");
function $cc05409771aeea55$export$71511d61b312f219(arr) {
    return (0, $2zPWk._)(arr) || (0, $91t4N._)(arr) || (0, $537SV._)(arr) || (0, $eTJIp._)();
}

});
parcelRegister("2zPWk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1e0723cca33e235d$export$71511d61b312f219; });

var $a3d64 = parcelRequire("a3d64");
function $1e0723cca33e235d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $a3d64._)(arr);
}

});
parcelRegister("a3d64", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $751457f6259d374a$export$71511d61b312f219; });
function $751457f6259d374a$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("91t4N", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $691ac3035b950bbe$export$71511d61b312f219; });
function $691ac3035b950bbe$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("eTJIp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ad89a9d214926ab2$export$71511d61b312f219; });
function $ad89a9d214926ab2$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("537SV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3ad35952737de5da$export$71511d61b312f219; });

var $a3d64 = parcelRequire("a3d64");
function $3ad35952737de5da$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $a3d64._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $a3d64._)(o, minLen);
}

});


parcelRegister("LCZef", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $5e37999a99b848cc$export$57bf213be019eeb0; });
$parcel$export(module.exports, "hide", function () { return $5e37999a99b848cc$export$fe8985bb6374093c; });
$parcel$export(module.exports, "fadeIn", function () { return $5e37999a99b848cc$export$82e6205b15e6c637; });
$parcel$export(module.exports, "fadeOut", function () { return $5e37999a99b848cc$export$c091916f1530334c; });
$parcel$export(module.exports, "slideUp", function () { return $5e37999a99b848cc$export$deed561b1a0ff1ea; });
$parcel$export(module.exports, "slideDown", function () { return $5e37999a99b848cc$export$abdd11a06a163232; });
$parcel$export(module.exports, "slideIn", function () { return $5e37999a99b848cc$export$d08c54023c399c9c; });
$parcel$export(module.exports, "slideOut", function () { return $5e37999a99b848cc$export$388d063d19975bb; });
$parcel$export(module.exports, "isVisible", function () { return $5e37999a99b848cc$export$795910f5f15a9633; });

var $hvZMf = parcelRequire("hvZMf");
var $5e37999a99b848cc$export$57bf213be019eeb0 = function(element, options) {
    if (element) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.display = display === 'none' ? 'block' : display;
        (options === null || options === void 0 ? void 0 : options.addClasses) && (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        (options === null || options === void 0 ? void 0 : options.removeClasses) && (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        element.offsetHeight;
    }
};
var $5e37999a99b848cc$export$fe8985bb6374093c = function(element, options) {
    if (element) {
        var _element_classList, _element_classList1;
        element.style.display = 'none';
        (options === null || options === void 0 ? void 0 : options.addClasses) && (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        (options === null || options === void 0 ? void 0 : options.removeClasses) && (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
    }
};
var $5e37999a99b848cc$export$82e6205b15e6c637 = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element && ((options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) === undefined || (options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) && window.getComputedStyle(element).display === 'none')) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.opacity = '0';
        element.style.visibility = 'hidden';
        element.style.display = display === 'none' ? 'block' : display;
        // Force CSS Reflow
        element.offsetHeight;
        element.style.transition = "opacity ".concat(duration, "ms linear");
        element.style.visibility = 'visible';
        element.style.opacity = '1';
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.removeProperty('opacity');
            element.style.removeProperty('visibility');
            element.style.removeProperty('transition');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$c091916f1530334c = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element && ((options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) === undefined || (options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) && window.getComputedStyle(element).display !== 'none')) {
        var _element_classList, _element_classList1;
        element.style.transition = "opacity ".concat(duration, "ms linear");
        element.style.opacity = '0';
        // Force CSS Reflow
        element.offsetHeight;
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.display = 'none';
            element.style.removeProperty('transition');
            element.style.removeProperty('opacity');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$75d3d2c72ecccf9b = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        if (window.getComputedStyle(element).display === 'none') return $5e37999a99b848cc$export$82e6205b15e6c637(element, duration, options);
        else return $5e37999a99b848cc$export$c091916f1530334c(element, duration, options);
    }
};
var $5e37999a99b848cc$export$deed561b1a0ff1ea = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = duration + 'ms';
        element.style.height = element.offsetHeight + 'px';
        // Force CSS Reflow
        element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = '0';
        element.style.paddingTop = '0';
        element.style.paddingBottom = '0';
        element.style.marginTop = '0';
        element.style.marginBottom = '0';
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.display = 'none';
            element.style.removeProperty('height');
            element.style.removeProperty('padding-top');
            element.style.removeProperty('padding-bottom');
            element.style.removeProperty('margin-top');
            element.style.removeProperty('margin-bottom');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$abdd11a06a163232 = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.display = display === 'none' ? 'block' : display;
        var height = element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = '0';
        element.style.paddingTop = '0';
        element.style.paddingBottom = '0';
        element.style.marginTop = '0';
        element.style.marginBottom = '0';
        // Force CSS Reflow
        element.offsetHeight;
        element.style.boxSizing = 'border-box';
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = duration + 'ms';
        element.style.height = height + 'px';
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.removeProperty('height');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$715de50cedc228a8 = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        if (window.getComputedStyle(element).display === 'none') return $5e37999a99b848cc$export$abdd11a06a163232(element, duration, options);
        else return $5e37999a99b848cc$export$deed561b1a0ff1ea(element, duration, options);
    }
};
var $5e37999a99b848cc$export$d08c54023c399c9c = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.left = "-".concat(element.offsetWidth, "px");
        element.style.display = 'none';
        element.style.removeProperty('display');
        element.style.left = "-".concat(element.offsetWidth, "px");
        element.style.display = display === 'none' ? 'block' : display;
        element.style.transitionProperty = 'left';
        element.style.transitionDuration = duration + 'ms';
        element.style.left = (options === null || options === void 0 ? void 0 : options.distance) !== undefined ? "".concat(options.distance, "px") : '';
        document.documentElement.classList.add('mobile-behind');
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _element_querySelector, _options_callback;
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            (_element_querySelector = element.querySelector('a, button')) === null || _element_querySelector === void 0 ? void 0 : _element_querySelector.focus();
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$388d063d19975bb = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        var distance = "-".concat(window.getComputedStyle(element).width);
        element.style.transitionProperty = 'left';
        element.style.transitionDuration = duration + 'ms';
        element.style.left = distance;
        document.documentElement.classList.remove('mobile-behind');
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_toggle, _options_callback;
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            element.style.display = 'none';
            options === null || options === void 0 ? void 0 : (_options_toggle = options.toggle) === null || _options_toggle === void 0 ? void 0 : _options_toggle.focus();
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$795910f5f15a9633 = function(element) {
    if (!element || !element.isConnected) return false;
    if (element.getClientRects().length === 0) return false;
    var style = getComputedStyle(element);
    if (style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    var rect = element.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    if (style.opacity === '0') return false;
    return true;
};

});


var $hvZMf = parcelRequire("hvZMf");

var $LCZef = parcelRequire("LCZef");
var $e5e184f2f5d20a54$var$laboratoryTests = document.querySelectorAll('.lab-card');
var $e5e184f2f5d20a54$var$searchInput = document.getElementById('lab-text-input');
var $e5e184f2f5d20a54$var$categoryFilterGroups = document.querySelectorAll('.category-filter');
var $e5e184f2f5d20a54$var$categoryFilterToggles = document.querySelectorAll('.category-filter summary');
var $e5e184f2f5d20a54$var$categoryFilters = document.querySelectorAll('.category-filter input[type=checkbox]');
var $e5e184f2f5d20a54$var$totalMatchingText = document.querySelector('.lab-total');
var $e5e184f2f5d20a54$var$clearFiltersButton = document.querySelector('.clear-filters');
var $e5e184f2f5d20a54$var$alertMessage = document.querySelector('.alert-message');
var $e5e184f2f5d20a54$var$buttonFilters = document.querySelectorAll('.button-filter');
var $e5e184f2f5d20a54$var$updateFilterCounts = function(selectedCategories) {
    $e5e184f2f5d20a54$var$categoryFilterToggles.forEach(function(toggle) {
        var selectedCountText = toggle.querySelector('.category-count');
        if (selectedCountText) {
            if (selectedCategories && toggle.dataset.id && selectedCategories[toggle.dataset.id]) selectedCountText.innerText = "(".concat(selectedCategories[toggle.dataset.id].length, ")");
            else selectedCountText.innerText = '';
        }
    });
};
var $e5e184f2f5d20a54$var$getLabsMatchingText = function(labCards) {
    if (($e5e184f2f5d20a54$var$searchInput === null || $e5e184f2f5d20a54$var$searchInput === void 0 ? void 0 : $e5e184f2f5d20a54$var$searchInput.value) && $e5e184f2f5d20a54$var$searchInput.value.length > 2) {
        var searchString = $e5e184f2f5d20a54$var$searchInput.value.toLowerCase();
        return labCards.filter(function(labCard) {
            var _labTitleElement_innerText;
            var found = false;
            var labTitleElement = labCard.querySelector('a');
            var labAbstractElement = labCard.querySelector('p');
            if (labTitleElement === null || labTitleElement === void 0 ? void 0 : (_labTitleElement_innerText = labTitleElement.innerText) === null || _labTitleElement_innerText === void 0 ? void 0 : _labTitleElement_innerText.toLowerCase().includes(searchString)) {
                found = true;
                $e5e184f2f5d20a54$var$addHighlights(labTitleElement, searchString);
            }
            if (labAbstractElement === null || labAbstractElement === void 0 ? void 0 : labAbstractElement.innerText.toLowerCase().includes(searchString)) {
                found = true;
                $e5e184f2f5d20a54$var$addHighlights(labAbstractElement, searchString);
            }
            return found;
        });
    } else return labCards;
};
var $e5e184f2f5d20a54$var$addHighlights = function(element, searchPhrase) {
    var rx = new RegExp("(".concat(searchPhrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), ")"), 'gi');
    element.innerHTML = element.innerHTML.replace(rx, '<span class="search-highlight">$1</span>');
};
var $e5e184f2f5d20a54$var$removeHighlightTag = function(labHighlight) {
    var _labHighlight_parentElement;
    if ((_labHighlight_parentElement = labHighlight.parentElement) === null || _labHighlight_parentElement === void 0 ? void 0 : _labHighlight_parentElement.innerHTML) {
        labHighlight.replaceWith("Test");
        labHighlight.parentElement.innerHTML = labHighlight.parentElement.innerHTML.replace(labHighlight.outerHTML, labHighlight.innerHTML);
    }
};
var $e5e184f2f5d20a54$var$getLabsMatchingCategories = function(labCards) {
    var selectedCategories = (0, $hvZMf._)($e5e184f2f5d20a54$var$categoryFilterGroups).reduce(function(accumulator, categoryGroup) {
        var _categoryGroup_dataset;
        var checkedCategories = categoryGroup.querySelectorAll('input:checked');
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = checkedCategories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var checkbox = _step.value;
                if ((_categoryGroup_dataset = categoryGroup.dataset) === null || _categoryGroup_dataset === void 0 ? void 0 : _categoryGroup_dataset.id) {
                    if (accumulator[categoryGroup.dataset.id]) accumulator[categoryGroup.dataset.id].push(checkbox.value);
                    else accumulator[categoryGroup.dataset.id] = [
                        checkbox.value
                    ];
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return accumulator;
    }, {});
    $e5e184f2f5d20a54$var$updateFilterCounts(selectedCategories);
    if (Object.keys(selectedCategories).length) {
        $e5e184f2f5d20a54$var$buttonFilters.forEach(function(button) {
            button.disabled = Object.keys(selectedCategories).some(function(parentId) {
                return button.dataset.category && selectedCategories[parentId].includes(button.dataset.category);
            });
        });
        return labCards.filter(function(labCard) {
            var _labCard_dataset_categories;
            var categories = (_labCard_dataset_categories = labCard.dataset.categories) === null || _labCard_dataset_categories === void 0 ? void 0 : _labCard_dataset_categories.split('|');
            return (categories === null || categories === void 0 ? void 0 : categories.length) && Object.keys(selectedCategories).every(function(parentId) {
                return selectedCategories[parentId].some(function(checkedCategory) {
                    return categories.includes(checkedCategory);
                });
            });
        });
    } else {
        $e5e184f2f5d20a54$var$buttonFilters.forEach(function(button) {
            return button.disabled = false;
        });
        return labCards;
    }
};
var $e5e184f2f5d20a54$var$debounceInterval;
$e5e184f2f5d20a54$var$searchInput === null || $e5e184f2f5d20a54$var$searchInput === void 0 ? void 0 : $e5e184f2f5d20a54$var$searchInput.addEventListener('input', function() {
    $e5e184f2f5d20a54$var$searchInput.value.length > 0 && $e5e184f2f5d20a54$var$searchInput.value.length < 3 ? (0, $LCZef.show)($e5e184f2f5d20a54$var$alertMessage) : (0, $LCZef.hide)($e5e184f2f5d20a54$var$alertMessage);
    clearInterval($e5e184f2f5d20a54$var$debounceInterval);
    $e5e184f2f5d20a54$var$debounceInterval = setInterval(function() {
        var _highlightTag;
        var matchingLabCards;
        document.querySelectorAll('.lab-card-container .search-highlight').forEach(function(highlightTag) {
            return (_highlightTag = highlightTag).replaceWith.apply(_highlightTag, (0, $hvZMf._)(highlightTag.childNodes));
        });
        if (($e5e184f2f5d20a54$var$searchInput === null || $e5e184f2f5d20a54$var$searchInput === void 0 ? void 0 : $e5e184f2f5d20a54$var$searchInput.value) && $e5e184f2f5d20a54$var$searchInput.value.length > 2) {
            (0, $LCZef.hide)($e5e184f2f5d20a54$var$alertMessage);
            matchingLabCards = $e5e184f2f5d20a54$var$getLabsMatchingText((0, $hvZMf._)($e5e184f2f5d20a54$var$laboratoryTests));
            matchingLabCards = $e5e184f2f5d20a54$var$getLabsMatchingCategories(matchingLabCards);
            $e5e184f2f5d20a54$var$laboratoryTests.forEach(function(labCard) {
                return (0, $LCZef.hide)(labCard);
            });
            matchingLabCards.forEach(function(labCard) {
                return (0, $LCZef.fadeIn)(labCard, 200, {
                    animateOnlyIfToggled: true
                });
            });
            if ($e5e184f2f5d20a54$var$totalMatchingText) $e5e184f2f5d20a54$var$totalMatchingText.innerText = "".concat(matchingLabCards.length);
        } else {
            matchingLabCards = $e5e184f2f5d20a54$var$getLabsMatchingCategories((0, $hvZMf._)($e5e184f2f5d20a54$var$laboratoryTests));
            matchingLabCards.forEach(function(labCard) {
                return (0, $LCZef.fadeIn)(labCard, 200, {
                    animateOnlyIfToggled: true
                });
            });
        }
        if ($e5e184f2f5d20a54$var$totalMatchingText) $e5e184f2f5d20a54$var$totalMatchingText.innerText = "".concat(matchingLabCards.length);
        clearInterval($e5e184f2f5d20a54$var$debounceInterval);
        $e5e184f2f5d20a54$var$debounceInterval = undefined;
    }, 500);
});
$e5e184f2f5d20a54$var$categoryFilters.forEach(function(filter) {
    return filter.addEventListener('change', function() {
        ($e5e184f2f5d20a54$var$searchInput === null || $e5e184f2f5d20a54$var$searchInput === void 0 ? void 0 : $e5e184f2f5d20a54$var$searchInput.value) && $e5e184f2f5d20a54$var$searchInput.value.length > 0 && $e5e184f2f5d20a54$var$searchInput.value.length < 3 ? (0, $LCZef.show)($e5e184f2f5d20a54$var$alertMessage) : (0, $LCZef.hide)($e5e184f2f5d20a54$var$alertMessage);
        var matchingLabCards = $e5e184f2f5d20a54$var$getLabsMatchingCategories((0, $hvZMf._)($e5e184f2f5d20a54$var$laboratoryTests));
        matchingLabCards = $e5e184f2f5d20a54$var$getLabsMatchingText(matchingLabCards);
        $e5e184f2f5d20a54$var$laboratoryTests.forEach(function(labCard) {
            return (0, $LCZef.hide)(labCard);
        });
        matchingLabCards.forEach(function(labCard) {
            return (0, $LCZef.fadeIn)(labCard, 200, {
                animateOnlyIfToggled: true
            });
        });
        if ($e5e184f2f5d20a54$var$totalMatchingText) $e5e184f2f5d20a54$var$totalMatchingText.innerText = "".concat(matchingLabCards.length);
    });
});
$e5e184f2f5d20a54$var$clearFiltersButton === null || $e5e184f2f5d20a54$var$clearFiltersButton === void 0 ? void 0 : $e5e184f2f5d20a54$var$clearFiltersButton.addEventListener('click', function() {
    var _highlightTag;
    if ($e5e184f2f5d20a54$var$searchInput) $e5e184f2f5d20a54$var$searchInput.value = '';
    $e5e184f2f5d20a54$var$categoryFilterGroups.forEach(function(filterGroup) {
        return filterGroup.querySelectorAll('input:checked').forEach(function(input) {
            return input.checked = false;
        });
    });
    document.querySelectorAll('.button-filter').forEach(function(button) {
        return button.disabled = false;
    });
    (0, $LCZef.hide)($e5e184f2f5d20a54$var$alertMessage);
    if ($e5e184f2f5d20a54$var$totalMatchingText) $e5e184f2f5d20a54$var$totalMatchingText.innerText = "".concat($e5e184f2f5d20a54$var$laboratoryTests.length);
    $e5e184f2f5d20a54$var$updateFilterCounts();
    document.querySelectorAll('.lab-card-container .search-highlight').forEach(function(highlightTag) {
        return (_highlightTag = highlightTag).replaceWith.apply(_highlightTag, (0, $hvZMf._)(highlightTag.childNodes));
    });
    $e5e184f2f5d20a54$var$laboratoryTests.forEach(function(labCard) {
        return (0, $LCZef.fadeIn)(labCard, 200, {
            animateOnlyIfToggled: true
        });
    });
});
$e5e184f2f5d20a54$var$buttonFilters.forEach(function(button) {
    button.addEventListener('click', function() {
        var _button_dataset;
        if ((_button_dataset = button.dataset) === null || _button_dataset === void 0 ? void 0 : _button_dataset.category) {
            document.querySelectorAll('.button-filter[data-category="'.concat(button.dataset.category, '"]')).forEach(function(matchingButton) {
                return matchingButton.disabled = true;
            });
            $e5e184f2f5d20a54$var$categoryFilterGroups.forEach(function(filterGroup) {
                (0, $hvZMf._)(filterGroup.querySelectorAll('input')).filter(function(checkbox) {
                    var _button_dataset;
                    return checkbox.value === ((_button_dataset = button.dataset) === null || _button_dataset === void 0 ? void 0 : _button_dataset.category);
                }).forEach(function(checkbox) {
                    return checkbox.checked = true;
                });
                var matchingLabCards = $e5e184f2f5d20a54$var$getLabsMatchingText((0, $hvZMf._)($e5e184f2f5d20a54$var$laboratoryTests));
                matchingLabCards = $e5e184f2f5d20a54$var$getLabsMatchingCategories(matchingLabCards);
                $e5e184f2f5d20a54$var$laboratoryTests.forEach(function(labCard) {
                    return (0, $LCZef.hide)(labCard);
                });
                matchingLabCards.forEach(function(labCard) {
                    return (0, $LCZef.fadeIn)(labCard, 200, {
                        animateOnlyIfToggled: true
                    });
                });
                if ($e5e184f2f5d20a54$var$totalMatchingText) $e5e184f2f5d20a54$var$totalMatchingText.innerText = "".concat(matchingLabCards.length);
            });
        }
    });
});
$e5e184f2f5d20a54$var$categoryFilterToggles.forEach(function(toggle) {
    return toggle.addEventListener('click', function() {
        if (toggle.ariaExpanded === 'true') {
            var _toggle_ariaControlsElements;
            (0, $LCZef.slideUp)((_toggle_ariaControlsElements = toggle.ariaControlsElements) === null || _toggle_ariaControlsElements === void 0 ? void 0 : _toggle_ariaControlsElements[0], 200);
            toggle.ariaExpanded = 'false';
        } else {
            var _toggle_ariaControlsElements1;
            (0, $LCZef.slideDown)((_toggle_ariaControlsElements1 = toggle.ariaControlsElements) === null || _toggle_ariaControlsElements1 === void 0 ? void 0 : _toggle_ariaControlsElements1[0], 200);
            toggle.ariaExpanded = 'true';
            $e5e184f2f5d20a54$var$categoryFilterToggles.forEach(function(filterToggle) {
                if (filterToggle !== toggle) {
                    var _filterToggle_ariaControlsElements;
                    filterToggle.ariaExpanded = 'false';
                    (0, $LCZef.slideUp)((_filterToggle_ariaControlsElements = filterToggle.ariaControlsElements) === null || _filterToggle_ariaControlsElements === void 0 ? void 0 : _filterToggle_ariaControlsElements[0], 200);
                }
            });
        }
    });
});

})();
//# sourceMappingURL=LabTestListing.js.map
